import i18next from 'i18next'
import React from 'react'
import { InView } from 'react-intersection-observer'
import { TabButton } from '../../../utils/buttons'
import { blockInviewHandler } from '../../../utils/inview'
import { SearchTab, searchTabs } from './searchState'
import { TopFilters, filteredUrl } from '../filters/filtersUtils'
import { DataLayer } from '../../../utils/datalayer'

type SearchTabsProps = {
  activeTab: SearchTab
  term: string
  topFilters?: TopFilters
  searchResultsCounts: { [searchTab in SearchTab]?: number }
}

export const SearchTabs = (p: SearchTabsProps) => (
  <div
    role="tablist"
    className="block__tabs tabs"
    aria-controls="a11y-search-results"
    aria-label={i18next.t('search:categories')}
  >
    {searchTabs.map((tab) => {
      const tabCount = p.searchResultsCounts[tab]
      const isActive = tab === p.activeTab
      const url = filteredUrl(`search`)({
        term: p.term,
        searchTab: tab,
        topFilters: p.topFilters,
      })

      return (
        <TabButton
          key={tab}
          isActive={isActive}
          to={url}
          label={`${i18next.t(`search:${tab}Tab`)}${` (${tabCount})`}`}
          htmlAttributes={{
            tabIndex: isActive ? 0 : -1,
            id: `a11y-search-btn-${tab}`,
            'aria-controls': `a11y-search-panel-${tab}`,
            'aria-selected': isActive,
          }}
          onClick={() => {
            DataLayer.internalSearch(
              p.term,
              tab,
              i18next.language,
              window.location.pathname
            )
          }}
        />
      )
    })}
  </div>
)

export const SearchResultsWrapper = (props: {
  searchTab: SearchTab
  child: JSX.Element
}) => (
  <div
    role="tabpanel"
    id={`a11y-search-panel-${props.searchTab}`}
    aria-labelledby={`a11y-search-btn-${props.searchTab}`}
    className="tabs__panel"
  >
    {props.child}
  </div>
)

export const SearchHeader = (props: { title: string }) => (
  <header className="block__header block__header--search">
    <h2
      className="block__title title--xs"
      dangerouslySetInnerHTML={{ __html: props.title }}
    />
  </header>
)

export const SearchResultsAndPaginationWrapper = (props: {
  child: JSX.Element
}) => (
  <>
    <h1 className="sr-text">{i18next.t('search:searchResults')}</h1>
    <InView
      as="section"
      threshold={0}
      triggerOnce={true}
      onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
      className="block block--search-results container--m gutter--m"
    >
      <div id="a11y-search-results" className="block__inner">
        {props.child}
      </div>
    </InView>
  </>
)
